
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/account/my-vehicles",
      function () {
        return require("private-next-pages/[locale]/account/my-vehicles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/account/my-vehicles"])
      });
    }
  